import { TmsRouteType } from 'app/constants/tmsRouteType'

export const getTmsRouteTypeColor = (type: TmsRouteType) => {
  let color = '#A0A0A0'

  switch (type) {
    case TmsRouteType.Bilateral:
    case TmsRouteType.Export:
    case TmsRouteType.Import:
      color = '#8BC23B'
      break
    case TmsRouteType.CrossTrade:
    case TmsRouteType.CrossTradeBilateral:
    case TmsRouteType.CrossTradeWrong:
      color = '#F5C02C'
      break
    case TmsRouteType.Domestic:
      color = '#808080'
      break
    case TmsRouteType.Cabotage:
      color = '#DD4D69'
      break
    case TmsRouteType.Transit:
      color = '#5B7F00'
      break
    case TmsRouteType.Empty:
    case TmsRouteType.CabotageEmpty:
    case TmsRouteType.CrossTradeWrongEmpty:
    case TmsRouteType.CrossTradeBilateralEmpty:
      color = '#0094FF'
      break
  }

  return color
}
